import React from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';

const Hero = () => {
    return (
        <section className="hero">
            <div className="hero-content">
                <div className="promo-banner">
                    -20% sur votre première réservation !
                </div>
                <h1>Nettoyage écologique professionnel</h1>
                <p>
                    Des solutions de nettoyage respectueuses de l'environnement pour votre maison et votre voiture.
                    Découvrez la différence d'un nettoyage professionnel et éco-responsable.
                </p>
                <div className="hero-cta">
                    <Link to="/booking" className="cta-button">
                        Réserver maintenant
                    </Link>
                    <Link to="/contact" className="cta-button cta-secondary">
                        Nous contacter
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default Hero;
